import * as yup from 'yup'
// Document types for Argentina
// export const documentoTypes = ['1-DNI', '2-LE', '3-LI', '4-CI PF', '5-Pasaporte']

// Yup schema for personal data form
export const datosPersonalesSchema = yup.object().shape({
  tipoDocumento: yup
    .number()
    .oneOf([1, 2, 3, 4, 5], 'Seleccioná un tipo de documento válido')
    .required('Seleccioná un tipo de documento *'),
  documento: yup
    .string()
    .trim()
    // .required('Ingresá tu documento *')
    .matches(/^[0-9.]+$/, 'El documento solo debe contener números')
    .test('documento-range', 'El documento debe estar entre 1.000.000 y 99.999.999', function (value) {
      if (!value || value.trim() === '') return true
      const cleaned = value.replace(/\./g, '')
      const num = parseInt(cleaned, 10)
      return !isNaN(num) && num >= 1000000 && num <= 99999999
    }),
  nombreCompleto: yup
    .string()
    .trim()
    .matches(/^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]+$/, 'Solo letras y espacios')
    .min(2, 'Ingresá tu nombre y apellido *'),
  // .required('Ingresá tu nombre y apellido *'),
  celular: yup
    .string()
    .trim()
    .test('celular-valid', 'Número de celular inválido (ej: 11 34567890)', function (value) {
      if (!value || value.trim() === '') {
        return true
      }
      const regex = /^(?:(?:00)?549?)?0?(11|[2368]\d)(?:(?=\d{0,2}15)?\d{2})??\d{8}$/
      return regex.test(value)
    }),
  // .required('Ingresá tu número de celular *'),
})
